var ModalButtonType;
(function (ModalButtonType) {
    /**
     * Cancel button type, will get the SECONDARY button theme.
     */
    ModalButtonType["CANCEL"] = "cancel";
    /**
     * Success button type, will get the PRIMARY button theme.
     */
    ModalButtonType["SUCCESS"] = "success";
})(ModalButtonType || (ModalButtonType = {}));
export default ModalButtonType;
//# sourceMappingURL=modal-button-type.js.map